import {get} from "./http_client";
import {next_replay_api_replays_path} from "@/routes";
import {api_replay_path, comments_api_replay_path} from "../routes";

export const nextReplay = () => get({url: next_replay_api_replays_path()})
export const show = replayID => get({url: api_replay_path(replayID)})
export const comments = replayID => get({url: comments_api_replay_path(replayID)})